//

export const MAIN_CHAIN = 'eth'
export const MAIN_CURRENCY = 'ETH'

export const MAIN_SITE_LINK = 'https://ncx.cx'
export const SITE_HOME_LINK = 'https://eth.ncx.nx'
export const SITE_DOMAIN = 'eth.ncx.cx'

export const BUY_CRYPTO_LINK = 'https://ncx.cx/buy-crypto'
export const SPOT_TRADING_LINK = 'https://trade.ncx.cx'
export const DERIVATIVES_LINK = 'https://derivatives.ncx.cx'
export const MARKETS_LINK = 'https://ncx.cx/markets'
export const DEX_SINGLE_LINK = '/swap'
export const DEX_LINK = 'https://dex.ncx.cx/swap'
export const NCX_CARD_LINK = 'https://ncx.cx/ncx-card'
export const NCX_WALLET_LINK = 'https://ncx.cx/wallet'
export const NCX_TOKEN_LINK = 'https://ncx.cx/ncx-token'
export const REWARDS_PROGRAM_LINK = 'https://ncx.cx/task-rewards'
export const NEWS_INSIGHTS_LINK = 'https://ncx.cx/insights'
export const SIGNUP_LINK = 'https://exchange.ncx.cx/register'
export const SIGNIN_LINK = 'https://exchange.ncx.cx/login'
export const MARKET_MAKERS_LINK = 'https://ncx.cx/market-makers'
export const INSTITUTIONAL_SERVICES_LINK = 'https://ncx.cx/institutional'
export const OTC_LINK = 'https://ncx.cx/ncx-otc'
export const NCX_TRENDS_LINK = 'https://ncx.cx/insights'
export const NCX_AMBASSADOR_LINK = 'https://ncx.cx/ncx-ambassador'
export const ABOUT_US_LINK = 'https://ncx.cx/about'
export const MEDIA_PRESS_LINK = 'https://ncx.cx/insights'
export const FAQ_LINK = 'https://ncx.cx/faq'
export const USER_AGREEMENT_LINK = 'https://ncx.cx/user-agreement'
export const AML_KYC_LINK = 'https://ncx.cx/kyc-aml-policy'
export const PRIVACY_POLICY_LINK = 'https://ncx.cx/privacy-policy'
export const API_DOCUMENT_LINK = 'https://ncx.cx/api-agreement'
export const COOKIE_POLICY_LINK = 'https://ncx.cx/cookie-policy'

export const TELEGRAM_LINK = 'https://t.me'
export const TWITTER_LINK = 'https://twitter.com/NCX_CX'
export const INSTAGRAM_LINK = 'https://www.instagram.com/ncx.cx'

const CURRENCY_SYMBOLS = {
  1: 'ETH',
  56: 'BNB',
}

export const getCurrencySymbol = (chainId?: number) => {
  if (!chainId) return 'ETH'
  if (!CURRENCY_SYMBOLS[chainId]) return 'ETH'
  return CURRENCY_SYMBOLS[chainId]
}
